import { render, staticRenderFns } from "./AssessmentTypesComponent.vue?vue&type=template&id=ee694632&"
import script from "./AssessmentTypesComponent.vue?vue&type=script&lang=js&"
export * from "./AssessmentTypesComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentTypesComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports